// extracted by mini-css-extract-plugin
export default {"row":"NoteRow_row__8go58","title":"NoteRow_title__TDtX3 font-sm-medium","date":"NoteRow_date__Ptwt3 font-sm-regular"};